import {Switch} from "@mui/material";
import {useEffect, useState} from "react";

export default function BVASwitch({ value, onChange = () => ({}) }) {
  // States
  const [internalValue, setInternalValue] = useState(false)

  // Watchers
  useEffect(() => {
    if (value === false || value === true) {
      setInternalValue(value)
    }
  }, [value])

  // Methods
  const handleChange = () => {
    setInternalValue(!internalValue)
    onChange(!internalValue)
  }


  return (
    <div>
      <Switch checked={internalValue} onChange={handleChange} />
    </div>
  )
}